<template>
  <div class="adminHealth">
    <v-card>
      <v-container>
        <v-card class="mb-4">
          <v-col>
            <v-row>
              <v-col>
                Notification: {{ turn_on.toUpperCase() }}
              </v-col>
              <v-col>
                <v-btn @click="turnOn">Turn On Notification!</v-btn>
              </v-col>
              <v-col>
                <v-btn @click="turnOff" color="error">Turn Off Notification!</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="experiments"
          item-key="id"
          show-select
          :items-per-page="10"
          class="elevation-1"
          >
        </v-data-table>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn @click="showCurrent">Manual Scan</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="savechanges(selected)" color="accent">Save</v-btn>
          <v-btn @click="reload()" color="warning">Discard</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </div>
</template>

<script>
	import moment from 'moment';
    import {Admin_APIService} from '@/services/Admin_APIService';
    const apiService = new Admin_APIService(process.env.VUE_APP_BASE_URL);
    export default {
    name: 'AdminHealth',
    props: {
    },
    data:function(){
      return {
        turn_on: 'off',
        singleSelect: false,
        selected: [],
        headers: [
          { text: 'ID', value: 'id', align: ' d-none'},
          { text: 'Experiment', value: 'experiment' },
          { text: 'Equipment', value: 'equipment_id' },
        ],
        experiments: [
          {
            id: 1,
            experiment: 'INTERFERENCE',
            equipment_id: 'set_0',
          },
          {
            id: 2,
            experiment: 'INTERFERENCE',
            equipment_id: 'set_1',
          },
        ],
      }
    },
    computed: {
    },
    methods:{
      showCurrent(){
          window.open(
              process.env.VUE_APP_BASE_URL +
              "/api/health/scan.php"
          );
      },
      turnOn(){
        var self = this;
        window.open(
            process.env.VUE_APP_BASE_URL +
            "/api/health/on_off.php?to=1"
        );
        setTimeout(function(){
          self.getHealthNotify();
        },1000);
      },
      turnOff(){
        var self = this;
        window.open(
            process.env.VUE_APP_BASE_URL +
            "/api/health/on_off.php?to=0"
        );
        setTimeout(function(){
          self.getHealthNotify();
        },1000);
      },
      savechanges(selected){
        var self = this;
        apiService.setHealthConfig(JSON.stringify(selected))
        .then((response) => {
          alert("Saved changes!");
          self.reload();
        });
      },
      reload(){
        var self = this;
        apiService.getHealthConfig()
        .then((response) => {
            self.experiments = response.experiments;
            self.selected = response.enabled;
        });
      },
      getHealthConfig(){
        var self = this;
        apiService.getHealthConfig()
        .then((response) => {
            self.experiments = response.experiments;
            self.selected = response.enabled;
        });
      },
      getHealthNotify(){
        var self = this;
        apiService.getHealthNotify()
        .then((response) => {
            self.turn_on = response.turned;          
        });
      },
    },
    mounted:function(){
      var self = this;
      self.getHealthConfig();
      self.getHealthNotify();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>